import Firebase from 'firebase'
export const config = {
    apiUrl : "https://backend-batch255.herokuapp.com/api",
    username : "maintener",
    image_path : "darifirebase",
    remember : "false",
    userid : "default",
    customerid:"lawd2120",
    token : "123",
    role : "user",
    otp : "1234",
    mobileOtp:"1234",
    biodata_id:"awhdwh",
    kategoriObat: "wdw222314ad", 
    searchObat: "awdwa5wwwd1111", 
    segmen: "awdawdwdwdw511", 
    hargaMin: "qsqsq511", 
    hargaMax: "511wsdwawd",
    hasilCariObat :"lebaransebentarlagiminalaidzinwalfaidzin",
    cariIdDoctor : "iddoctor",
    cariIdOfficeDoctor : "cariIdOfficeDoctor",
    hasilCariDoctor:"hasilcaridoctor",
    loc:"loc",
    spes:"spes",
    nameDoc:"nameDoc",
    tinMed:"tinMed",
    page:"page",
    pagesize:"pagesize",
    qtyProductObat:"99999995",
    jumlahHargaObat:"sarirotirotisariroti",
    appointment_date:"appDate"
}
const FirebaseConfig = {
    apiKey: "AIzaSyAbxxzBcgQiHu0ZrXx75JeTadoSXEUm4S4",
    authDomain: "medxsis255.firebaseapp.com",
    projectId: "medxsis255",
    storageBucket: "medxsis255.appspot.com",
    messagingSenderId: "246595118047",
    appId: "1:246595118047:web:4f39f9eadf64cfba37da6a",
    measurementId: "G-86GJY588FX"
  }
  Firebase.initializeApp(FirebaseConfig);

const storage = Firebase.storage()

export {storage, Firebase}